<template>
  <div>
    <v-autocomplete
      box
      :loading="loading"
      v-model="selected"
      clearable
      :items="items"
      :label="$t('Trabajador')"
      :multiple="multiple"
      chips
      :item-text="itemText"
      @input="onSelected"
      return-object
    ></v-autocomplete>
  </div>
</template>

<script>
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  props: {
    codempre: {
      type: [Number, String],
    },
    value: {
      type: Object,
    },
    itemText: {
      type: String,
      default: 'fullname',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    itemValue: {
      type: String,
      default: 'CODTRAB',
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      selected: this.value ? this.value : null,
    };
  },

  mounted() {
    if (this.codempre) {
      this.getEntities();
    }
  },
  methods: {
    async getEntities() {
      this.loading = true;
      this.$emit('loading');
      const res = await apiCtrl.get('/workers/all', { params: { CODEMPRE: this.codempre } });

      this.items = res.data.data;

      this.loading = false;
    },
    onSelected() {
      this.$emit('input', this.selected);
    },
  },
  watch: {
    codempre: function() {
      this.getEntities();
    },
  },
};
</script>

<style></style>
